<template>
  <div class="chat-input-box">
    <div class="chat-input-content">
      <textarea
        v-model="message"
        class="chat-input-field"
        :placeholder="placeholderText"
        @keydown="handleKeyPress"
        @input="handleInput"
        ref="chatInput"
        rows="3"
        style="color: rgba(255, 255, 255, 1) !important; caret-color: rgba(255, 255, 255, 1) !important;"
      ></textarea>
    </div>
    <div class="chat-input-actions">
      <button class="chat-action-btn attachment-btn" @click="handleAttachment">
        <v-icon size="16">mdi-paperclip</v-icon>
      </button>
      <button class="chat-action-btn send-btn" @click="handleSend" type="button" :disabled="loading">
        <v-progress-circular v-if="loading" indeterminate color="primary" size="20" width="2"></v-progress-circular>
        <img v-else :src="sendIcon" alt="Send" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatInputBox",
  props: {
    placeholderText: {
      type: String,
      default: "Let's create a dashboard...",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      message: "",
      sendIcon: require("@/assets/Images/Dashboard/send-2.png"),
    };
  },
  mounted() {
    // Focus the input when component is mounted
    this.$nextTick(() => {
      if (this.$refs.chatInput) {
        this.$refs.chatInput.focus();
      }
    });
  },
  methods: {
    handleAttachment() {
      // Handle file attachment
      this.$emit("attach-file");
    },
    handleSend() {
      if (this.message.trim()) {
        this.$emit("send-message", this.message);
        this.message = "";
        // Refocus after sending
        this.$nextTick(() => {
          if (this.$refs.chatInput) {
            this.$refs.chatInput.focus();
          }
        });
      }
    },
    handleKeyPress(event) {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        this.handleSend();
      }
    },
    handleInput(event) {
      // Ensure v-model is working
      this.message = event.target.value;
    },
  },
};
</script>

<style scoped>
@import '../../assets/Styling/agenticDashboard/chatInputBox.css';

.chat-input-field {
  color: rgba(255, 255, 255, 1) !important;
  caret-color: rgba(255, 255, 255, 1) !important;
}

.chat-input-field::placeholder,
.chat-input-field:not(:focus)::placeholder,
.chat-input-field::-webkit-input-placeholder,
.chat-input-field:not(:focus)::-webkit-input-placeholder,
.chat-input-field::-moz-placeholder,
.chat-input-field:not(:focus)::-moz-placeholder,
.chat-input-field:-ms-input-placeholder,
.chat-input-field:not(:focus):-ms-input-placeholder,
.chat-input-field:-moz-placeholder,
.chat-input-field:not(:focus):-moz-placeholder {
  color: rgba(255, 255, 255, 1) !important;
  opacity: 1 !important;
}
</style>

